export default __webpack_public_path__ + "static/media/money-location.95eb4cb2.svg";